<template>
	<div>
		<Modal
			:show="show"
			@close="closeModal"
			body-classes="m-0 pt-0 pb-0"
			:hideFooter="true"
			footer-classes="pt-0"
			header-classes="pb-1"
			size="lg"
		>
			<template v-slot:header>
				<h5 class="modal-title" id="modalTitle">Link Relationship</h5>
			</template>

			<b-overlay :show="isLoading" rounded="sm">
				<div class="pt-2" v-if="linkedUser">
					<h5 style="flex: auto; text-align: center">
						Link this member to {{ linkedUser.firstName }}
						{{ linkedUser.lastName }} as:
					</h5>
					<h6 v-if="errorMessage" style="color: red; flex: auto; text-align: center">
						{{ errorMessage }}
					</h6>
				</div>

				<form class="pt-1 pb-1">
					<BaseInput type="text" label="Relationship" name="relationshipType" required>
						<select
							class="form-control"
							id="linkRelationshipTypeSelect"
							v-model="relationshipType"
							required
						>
							<option
								v-for="options in relationshipTypeOptions"
								:key="options.value"
								:value="options.value"
							>
								{{ options.name }}
							</option>
						</select>
					</BaseInput>
					<b-row class="mr-0 mt-3 mb-3">
						<div style="flex-grow: 1"></div>
						<BaseButton
							type="primary"
							:loading="isLoading"
							:shake="shake"
							@click="submit"
							>Link Relationship</BaseButton
						>
					</b-row>
				</form>
			</b-overlay>
		</Modal>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
import BaseButton from '../BaseButton.vue';
import BaseInput from '../Inputs/BaseInput.vue';
import Modal from './Modal.vue';
import AppUserManager from '../../models/AppUser/AppUserManager';

export default {
	components: { Modal, BaseInput, BaseButton },
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		userData: null,
		linkedUser: null,
	},
	watch: {
		show: {
			handler() {
				this.errorMessage = null;
				this.shake = false;
				this.relationshipType = null;
			},
		},
	},
	data() {
		return {
			shake: false,
			isLoading: false,
			errorMessage: null,
			relationshipType: null,
			relationshipTypeOptions: [
				{ name: 'Spouse', value: 'spouse' },
				{ name: 'Child', value: 'child' },
				{ name: 'Parent', value: 'parent' },
				{ name: 'Cousin', value: 'cousin' },
				{ name: 'Nephew', value: 'nephew' },
				{ name: 'Uncle', value: 'uncle' },
				{ name: 'Niece', value: 'niece' },
				{ name: 'Aunt', value: 'aunt' },
				{ name: 'Grandparent', value: 'grandparent' },
				{ name: 'Grandchild', value: 'grandchild' },
				{ name: 'Other', value: 'other' },
			],
		};
	},
	methods: {
		...mapActions(['showNotification']),
		closeModal() {
			this.$emit('update:show', false);
			this.$emit('close');
		},
		submit() {
			if (this.$helpers.isBlank(this.relationshipType)) {
				this.errorMessage = 'Please select a relationship.';
				this.shake = true;
				return;
			}
			this.isLoading = true;
			AppUserManager.linkRelationship(
				this.userData.uid,
				this.linkedUser.uid,
				this.relationshipType
			)
				.then(() => {
					this.isLoading = false;
					this.$emit('linked');
					this.closeModal();
				})
				.catch((errorMessage) => {
					this.isLoading = false;
					this.showNotification({
						type: 'danger',
						message: errorMessage,
					});
				});
		},
	},
};
</script>
